// extracted by mini-css-extract-plugin
export default {"expiredCard":"JnqTac5Hlpeucm0uqrRi","expiredLabel":"qVTv8ns1Tjeaoe9gVubM"};